import debug from 'debug';
import pkgJson from '../../package.json';

const { config: { org: defaultOrg }, name: defaultRepo, version: defaultVersion } = pkgJson;

export default ({ org = defaultOrg, repo = defaultRepo, version = defaultVersion, src, method, logic } = {}) =>
  debug(`@${org}/${repo}/v${version}/${src}${method ? `/${method}` : ''}${logic ? `:${logic}` : ''}`);



// WEBPACK FOOTER //
// ./src/lib/debug.js